import AddedPadding from './AddedPadding';

export default AddedPadding;
